import { PaymentIframeHandles, PaymentInitOptions, PaymentPageParams } from './types'
import { createIframe, IframeBridge } from '@web-publish-id/shared/helper'
import sharedConfig from '@web-publish-id/shared/config'
import { Logger, LogLevel } from '@web-publish-id/logger'
import { hasTrackSDK, initTrackSDK, trackEvent } from './track'

const iframeBridge = new IframeBridge()

/** 国服不向收银台传递埋点，也不转发 StarTrack */
const trackEnabled = !import.meta.env.MODE.startsWith('cn-')

class PaymentSDKCore {
  private client_id: string = ''
  private language: string
  private logger!: Logger

  constructor() {
    this.logger = new Logger({
      prefix: 'PaymentSDK',
      level: import.meta.env.PROD ? LogLevel.INFO : LogLevel.DEBUG,
    })
  }

  /**
   * 初始化
   */
  async init(params: PaymentInitOptions) {
    const { client_id, language } = params
    if (!client_id) {
      throw new Error('client_id is required')
    }

    this.client_id = client_id
    this.language = language

    this.logger.info('payment init', params)
  }

  /**
   * 嵌入支付页面
   * @param params 参数
   * @param handles 回调
   */
  setupPaymentPage(params: PaymentPageParams, handles: PaymentIframeHandles) {
    const { selector, sys_order_id, account_token, business_type, callback_url } = params
    const paymentElement = document.querySelector(selector)
    if (!paymentElement) {
      throw new Error('Payment element not found')
    }
    console.log('this.client_id :>> ', this.client_id)

    const urlParams = {
      client_id: this.client_id,
      sys_order_id,
      account_token,
      business_type,
      callback_url,
      window_mode: 'insert',
      origin: window.location.origin,
      language: this.language || navigator.language,
      // 是否外部集成事件跟踪SDK。国服不上报
      outer_track: trackEnabled && hasTrackSDK() ? '1' : undefined,
    }

    // 过滤掉没有值的参数
    Object.keys(urlParams).forEach((key) => {
      if (!urlParams[key]) {
        delete urlParams[key]
      }
    })

    const hostUrl = (import.meta.env.DEV ? 'http://127.0.0.1:12020' : sharedConfig.origin) + '/payment'

    const iframe = createIframe({
      url: hostUrl + '?' + new URLSearchParams(urlParams).toString(),
      appendId: selector,
    })

    iframeBridge.init(iframe, {
      onload: (payload) => {
        handles?.onLoad()
      },
      onerror: (e) => {
        handles?.onError(e)
      },
    })

    iframeBridge.on('order_event', (payload) => {
      const { type, data } = payload
      handles?.onEvent(type, data)
    })

    // 监听外部集成事件跟踪SDK。国服不注册，避免初始化或上报 StarTrack
    if (trackEnabled) {
      iframeBridge.on('outer_track', (payload) => {
        const { type, data } = payload

        try {
          const params = data ? JSON.parse(JSON.stringify(data)) : undefined

          switch (type) {
            case 'init':
              initTrackSDK(params)
              break
            case 'event':
              trackEvent(params)
              break
          }
        } catch (error) {
          this.logger.error('outer track error', error)
        }
      })
    }

    return {
      destroy: () => {
        iframeBridge.destroy()
      },
    }
  }
}

export default PaymentSDKCore
